import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import Dataloader from "../../Component/Dataloader";
import NoData from "../../Component/NoData";

export default function Faq() {
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiUrl}/config`);
      setData(response.data.faq);
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setExist(false);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="page-content">
      <div className="product-hero-area">
        <div className="product-hero-content">
          <h4 className="mb-1">Frequently Asked Questions</h4>
          <p className="mb-0">Answers to your most common queries</p>
        </div>
      </div>

      <div className="container-fluid">
        <div className="faq-row row-layout">
          {loading ? (
            <div className="row">
              <div className="col-lg-12">
                <div className="d-flex justify-content-center">
                  <Dataloader />
                </div>
              </div>
            </div>
          ) : (
            <>
              {exist ? (
                <div className="row">
                  <div className="col-lg-10 mx-auto">
                    {data &&
                      data.map((faq, index) => (
                        <div key={index} className="faq_item">
                          <button
                            type="button"
                            className="faq-content"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faq_${index}`}
                            aria-expanded="false"
                            aria-controls="collapseExample"
                          >
                            <h6 className="mb-0 text-dark">{faq.title}</h6>
                            <i className="bi bi-chevron-down"></i>
                          </button>
                          <div className="collapse" id={`faq_${index}`}>
                            <div className="faq-collapse">
                              <p>{faq.description}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-lg-12">
                    <NoData />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
